/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.commentModule').directive('bulbCommentButton', ['$timeout','$window','BulbCommentService','Foundation', bulbCommentButton])

function bulbCommentButton($timeout, $window, BulbCommentService, Foundation) {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/comment/commentbutton.html',
    scope: {
      unitId: '@',
      targetId: '@',
      threadCount: '='
    },
    link: function(scope, element, attrs) {

      var targetId = attrs.targetId;
      var nodeType = attrs.nodeType;

      if (attrs.editorType !== 'ckeditor') {
        // reposition
        var reposition = function() {
          var positionInformation = BulbCommentService.getTargetElementPosition(targetId);
          if (positionInformation) {
            // Need to move the comment button closer to the audio block if it is right aligned
            // The value for an audio block being right aligned is always: 383.5 on Chrome and 383 on Safari
            if (positionInformation.nodeName === 'AUDIO-BLOCK' && positionInformation.left >= 383) {
              element.css('left', positionInformation.left + 40);
            } else {
              element.css('left', positionInformation.left);
            }

            // Regardless of block-type, we want to update the blocks top value.
            element.css('top', positionInformation.top);

          } else {
            element.remove();
          }
        };

        reposition();

        BulbCommentService.currentMediumEditor.subscribe('editableInput', reposition);

        scope.$watch(function() {
          return BulbCommentService.getPageElementHeight();
        }, function() {
          $timeout(function() {
            reposition();
          }, 1);
        });
      } else {
        var repositionCke = function() {
          var positionInformation = BulbCommentService.getTargetElementPosition(targetId);
          if (positionInformation) {
            element.css('top', positionInformation.top);
            element.css('left', -15);
          } else {
            element.css('top','initial');
          }
        }

        repositionCke();
        scope.$watch(function() {
          return BulbCommentService.getPageElementHeight();
        }, function() {
          $timeout(function() {
            repositionCke();
          }, 1);
        });
      }
      

      element.on('click', function(event) {
        $timeout(function(){
          if (BulbCommentService.isSideCommentEnabled()) {
            BulbCommentService.switchCommentThreadVisible(targetId,'', nodeType);
          } else {
            var lowerComment = jQuery('#comment-lower-' + targetId);
            jQuery('html,body').animate({
              scrollTop: lowerComment.offset().top - 20
            });
          }
        }, 1);
        event.stopPropagation();
      });

      scope.isActive = function() {
        return BulbCommentService.isSideCommentEnabled() && BulbCommentService.currentTargetId === targetId;
      };

      scope.isUnread = function() {
        if (!BulbCommentService.commentThreadMap) {
          return false;
        }
        var threadList = BulbCommentService.commentThreadMap[targetId];
        var result = false;
        if (threadList) {
          if (threadList.length > 0) {
            for (var i = 0; i < threadList.length; i++) {
              if (threadList[i].unread) {
                result = true;
                break;
              }
            }
          }
        }
        return result;
      };

      var resizeHandler = function(){
        if (Foundation.utils.is_large_up()) { // jshint ignore:line
          element.show();
        } else {
          element.hide();
        }
      };

      resizeHandler();

      var window = jQuery($window);
      window.on('resize', resizeHandler);
      scope.$on('$destroy', function() {
        window.off('resize', resizeHandler);
      });
    }
  };
}
